<template>
  <v-layout column>
    <v-layout row v-if="receivables.length > 0">
      <invoicesDashboardArray
        :invoices="receivables"
        :currencyId="currencyId"
        operationType="credit"
        :companyBalance="companyBalance"
      />
    </v-layout>
    <v-layout row v-if="payables.length > 0">
      <invoicesDashboardArray
        :invoices="payables"
        :companyBalance="companyBalance"
        :currencyId="currencyId"
        operationType="debit"
      />
    </v-layout>

    <v-layout
      row
      wrap
      class="text-xs-center pa-5"
      v-if="receivables.length == 0 && payables.length === 0"
    >
      <v-flex xs12>
        <v-icon color="success" size="74">mdi-cash</v-icon>
        <v-icon
          style="position: relative; left: -22px; top: -16px;"
          class="white success--text"
          size="22"
          >mdi-check-bold</v-icon
        >
        <h3 class="title font-weight-light my-2">No Unreconciled Invoices.</h3>
        <span class="caption grey--text"
          >Looks like everything has been paid!</span
        >
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import currency from "../../../mixins/currency.js";
import date from "../../../mixins/date.js";
import invoicesDashboardArray from "./invoicesDashboardArray";

export default {
  name: "invoicesDashboard",
  mixins: [currency, date],
  components: { invoicesDashboardArray },
  props: {
    companyBalance: {
      type: Object,
      required: true,
    },
    invoices: {
      type: Array,
      required: true,
    },
    currencyId: {
      type: String,
      required: true,
    },
  },
  computed: {
    receivables() {
      var ret = this.invoices.filter((e) => {
        return (
          e.currency_id === this.currencyId &&
          ((e.operation_type === "credit" && !e.is_credit_note) ||
            (e.operation_type === "debit" && e.is_credit_note))
        );
      });
      ret.forEach((e) => {
        e.overdue = this.isDateInThePast(e.expected_payment_date);
      });
      return ret;
    },
    payables() {
      var ret = this.invoices.filter(
        (e) =>
          e.currency_id === this.currencyId &&
          ((e.operation_type === "debit" && !e.is_credit_note) ||
            (e.operation_type === "credit" && e.is_credit_note))
      );
      ret.forEach((e) => {
        e.overdue = this.isDateInThePast(e.expected_payment_date);
      });
      return ret;
    },
  },
};
</script>
